import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireWarning } from '../node_modules/warning/warning.js';

var warningExports = requireWarning();
var warning = /*@__PURE__*/getDefaultExportFromCjs(warningExports);

export { warning as default };
